/**
 * HELMAND market-aware language selector.
 *
 * The Liquid snippet supplies the country for each language button:
 *   lv -> LV (helmand.lv), lt -> LT (helmand.lt), et -> EE (helmand.ee).
 * Other languages keep the customer's current country/market.
 *
 * Submit language_code AND country_code in Shopify's native localization
 * form. Shopify resolves the configured market domain and localized page.
 * Do not construct URLs, strip translated paths, override return_to, fetch
 * /localization with AJAX, or redirect on page load.
 */
(function () {
  'use strict';

  // Protect against duplicate execution in theme-editor/dynamic contexts.
  if (window.helmandMarketLanguageBound) return;
  window.helmandMarketLanguageBound = true;

  var buttonSelector =
    'form.helmand-language-form button[name="language_code"][data-country-code]';

  function setSelectedCountry(button, form) {
    if (!button || !button.matches || !button.matches(buttonSelector)) return;
    if (button.disabled) return;

    form = form || button.form;
    if (!form || button.form !== form) return;

    var countryCode = button.getAttribute('data-country-code');
    var countryInput = form.querySelector('input[name="country_code"]');
    if (!countryInput || !/^[A-Z]{2}$/.test(countryCode || '')) return;

    // Set a value for EVERY selection, including RU/EN, so a previously
    // cancelled LT/ET selection cannot leave another country in this form.
    countryInput.value = countryCode;
  }

  // Capture runs before theme click handlers and the native form submission.
  // Delegation also covers mobile copies and sections reloaded by the editor.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    setSelectedCountry(target.closest(buttonSelector));
  }, true);

  // Covers requestSubmit(button) and keyboard submission. Older browsers
  // without SubmitEvent.submitter are covered by the native button click.
  document.addEventListener('submit', function (event) {
    setSelectedCountry(event.submitter, event.target);
  }, true);

  // Keep the browser's native POST. The clicked button contributes the
  // language_code; the hidden input contributes the selected country_code.
})();
